/* global restVar */
import { useState, useRef, useCallback } from '@wordpress/element';
import Webcam from 'react-webcam';
import Spinner from '../../shared/components/Spinner';
import IconFlashlight from './IconFlashlight';

const videoConstraints = {
	width: 720,
	height: 1280,
	aspectRatio: 0.6666666667,
	facingMode: { ideal: 'environment' },
};

export default function InsertarTicket( { insertedTicket } ) {
	const webcamRef = useRef( null );
	const [ imageSrc, setImageSrc ] = useState( null );
	const [ videoStream, setVideoStream ] = useState( null );
	const [ isTorch, setIsTorch ] = useState( false );
	const [ isTicketSaved, setIsTicketSaved ] = useState( false );
	const [ isSending, setIsSending ] = useState( false );

	const capture = useCallback( () => {
		setImageSrc( webcamRef.current.getScreenshot() );
	}, [ webcamRef ] );

	const handleClick = () => {
		setIsSending( true );
		fetch( restVar.sciBonosComercioEndpointTicket, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': restVar.nonce,
			},
			body: JSON.stringify( { insertedTicket, imageSrc } ),
		} )
			.then( ( response ) => {
				if ( ! response.ok ) {
					// eslint-disable-next-line no-console
					console.log( response );
					return;
				}
				return response.json();
			} )
			.then( () => {
				setIsTicketSaved( true );
			} )
			.catch( ( error ) => {
				// eslint-disable-next-line no-console
				console.error( error );
			} )
			.finally( () => {
				setIsSending( false );
				setImageSrc( null );
			} );
	};

	if ( isTicketSaved ) {
		return (
			<div className="sci-bcl-ticket sci-bcl-ticket--correcto sci-bcl-bonos__success">
				<p>Ticket guardado correctamente.</p>
			</div>
		);
	}

	return (
		<div className="sci-bcl-ticket">
			{ ! imageSrc && (
				<>
					<Webcam
						className="sci-bcl-ticket__webcam"
						ref={ webcamRef }
						screenshotFormat="image/jpeg"
						height={ 1280 }
						width={ 720 }
						minScreenshotHeight={ 1280 }
						minScreenshotWidth={ 720 }
						videoConstraints={ videoConstraints }
						onUserMedia={ ( stream ) => setVideoStream( stream ) }
					/>
					<div className="sci-bcl-ticket__btns">
						<button
							className="sci-bcl-ticket__fotobtn sci-bcl-btn"
							onClick={ capture }
						>
							Sacar foto
						</button>
						{
							<button
								className="sci-bcl-ticket__torchbtn sci-bcl-btn sci-bcl-btn--secondary"
								onClick={ () => {
									const track =
										videoStream.getVideoTracks()[ 0 ];
									const newTorchState = ! isTorch;
									track
										.applyConstraints( {
											advanced: [
												{ torch: newTorchState },
											],
										} )
										.then( () => {
											setIsTorch( newTorchState );
										} );
								} }
							>
								<IconFlashlight isTorch={ isTorch } />
							</button>
						}
					</div>
				</>
			) }
			{ imageSrc && (
				<>
					<img
						className="sci-bcl-ticket__captura"
						src={ imageSrc }
						alt="Captura del ticket"
					/>
					<div className="sci-bcl-ticket__btns">
						<button
							className="sci-bcl-ticket__fotobtn sci-bcl-btn sci-bcl-btn--secondary"
							onClick={ () => setImageSrc( null ) }
						>
							Sacar otra foto
						</button>
						<button
							className="sci-bcl-ticket__guardarbtn sci-bcl-btn"
							onClick={ handleClick }
						>
							Guardar ticket
						</button>
					</div>
				</>
			) }
			{ isSending && <Spinner /> }
		</div>
	);
}
